const ALPHA_MIN_SCORE_THRESHOLD = 0.2;
const ALPHA_MAX_SCORE_THRESHOLD = 0.8;
const LIMB_COLOR_RGB = '33, 150, 243';
const JOINT_COLOR_RGB = '255, 87, 34';
const LIMB_WIDTH = 8;

const JOINT_RADIUS = 6;
const FACE_KEYPOINTS = ['nose', 'left_eye', 'right_eye', 'left_ear', 'right_ear'];
const FACE_WIDTH_FALLBACK = 50;
const FACE_WIDTH_FROM_EYES_MULTIPLIER = 2.0;
const FACE_SCALE_MULTIPLIER = 1.0;

function scoreToAlpha(score) {
  if (score < ALPHA_MIN_SCORE_THRESHOLD) return 0;
  if (score > ALPHA_MAX_SCORE_THRESHOLD) return 1;
  return (score - ALPHA_MIN_SCORE_THRESHOLD) / (ALPHA_MAX_SCORE_THRESHOLD - ALPHA_MIN_SCORE_THRESHOLD);
}

function drawFace(ctx, scale, alpha, emojiImage) {
  if (!emojiImage) return;

  const size = scale * 1.2;
  ctx.globalAlpha = alpha;
  ctx.drawImage(emojiImage, -size / 2, -size / 2, size, size);
  ctx.globalAlpha = 1.0;
}

export function drawAnimatedCharacter(keypoints, ctx, emojiImage) {
  const anatomy = {};
  for (let point of keypoints) {
    anatomy[point.name] = point;
  }

  ctx.lineWidth = LIMB_WIDTH;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';

  const drawLimb = (start, end) => {
    const startPoint = anatomy[start];
    const endPoint = anatomy[end];

    if (startPoint && endPoint) {
      const startAlpha = scoreToAlpha(startPoint.score);
      const endAlpha = scoreToAlpha(endPoint.score);

      const gradient = ctx.createLinearGradient(
        startPoint.x, startPoint.y,
        endPoint.x, endPoint.y
      );
      gradient.addColorStop(0, `rgba(${LIMB_COLOR_RGB}, ${startAlpha})`);
      gradient.addColorStop(1, `rgba(${LIMB_COLOR_RGB}, ${endAlpha})`);

      ctx.strokeStyle = gradient;
      ctx.beginPath();
      ctx.moveTo(startPoint.x, startPoint.y);
      ctx.lineTo(endPoint.x, endPoint.y);
      ctx.stroke();
    }
  };

  drawLimb('left_shoulder', 'right_shoulder');
  drawLimb('left_shoulder', 'left_elbow');
  drawLimb('left_elbow', 'left_wrist');
  drawLimb('right_shoulder', 'right_elbow');
  drawLimb('right_elbow', 'right_wrist');

  drawLimb('left_shoulder', 'left_hip');
  drawLimb('right_shoulder', 'right_hip');
  drawLimb('left_hip', 'right_hip');

  drawLimb('left_hip', 'left_knee');
  drawLimb('left_knee', 'left_ankle');
  drawLimb('right_hip', 'right_knee');
  drawLimb('right_knee', 'right_ankle');

  const nose = anatomy['nose'];
  const leftEar = anatomy['left_ear'];
  const rightEar = anatomy['right_ear'];
  const leftEye = anatomy['left_eye'];
  const rightEye = anatomy['right_eye'];

  if (nose) {
    const headAlpha = scoreToAlpha(nose.score);

    let faceWidth = FACE_WIDTH_FALLBACK;
    let rotationAngle = 0;

    if (leftEar && rightEar) {
      faceWidth = Math.abs(leftEar.x - rightEar.x);
      rotationAngle = Math.atan2(leftEar.y - rightEar.y, leftEar.x - rightEar.x);
    } else if (leftEye && rightEye) {
      faceWidth = Math.abs(leftEye.x - rightEye.x) * FACE_WIDTH_FROM_EYES_MULTIPLIER;
      rotationAngle = Math.atan2(leftEye.y - rightEye.y, leftEye.x - rightEye.x);
    }

    const faceScale = faceWidth * FACE_SCALE_MULTIPLIER;

    if (emojiImage) {
      ctx.save();
      ctx.translate(nose.x, nose.y);
      ctx.rotate(rotationAngle);
      drawFace(ctx, faceScale, headAlpha, emojiImage);
      ctx.restore();
    }
  }

  for (let point of keypoints) {
    if (emojiImage && FACE_KEYPOINTS.includes(point.name)) {
      continue;
    }
    const alpha = scoreToAlpha(point.score);
    ctx.beginPath();
    ctx.arc(point.x, point.y, JOINT_RADIUS, 0, 2 * Math.PI);
    ctx.fillStyle = `rgba(${JOINT_COLOR_RGB}, ${alpha})`;
    ctx.fill();
  }
}
